import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeUnderScore'
})
export class RemoveUnderScorePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    value = value|| '';
    value = value.replace(/_/g,' ');
    return value;
  }

}
